const SkipContent = () => {
	return (
		<a className='skipper' href='#main'>
			Skip to main content
		</a>
	);
};

export default SkipContent;
